import { ref } from '@nuxtjs/composition-api';
const isTaboolaLoaded = ref(false);
export const initializeTaboolaHP4UArticle = (adTags) => {
  if (!isTaboolaLoaded.value) {
    adTags.script.push({
      hid: 'taboolaHP4UArticle',
      innerHTML: `
      window._newsroom = window._newsroom || [];
      if(!window.isTaboolaNewsroomLoaded) {
        window.isTaboolaNewsroomLoaded = true;
        !function (e, f, u) {
            e.async = 1;
            e.src = u;
            f.parentNode.insertBefore(e, f);
        
        }(document.createElement('script'),
                document.getElementsByTagName('script')[0], '//c2.taboola.com/nr/onedio/newsroom.js');
      }
      `,
      callback: () => {
        isTaboolaLoaded.value = true;
      },
    });
    adTags.__dangerouslyDisableSanitizersByTagID.taboolaHP4UArticle = ['innerHTML'];
  }
};
